import React from 'react'
import LocalizedLegalDocument from './LocalizedLegalDocument'

export default function PrivacyPolicy() {
  return <LocalizedLegalDocument documentKey='privacy' />
}
